<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>SITE BLOCKS</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
       <!-- <div class="flex p-5">
          <vs-checkbox v-model="isCustom" @change="newcheck(isCustom)">Add Custom HTML</vs-checkbox>
        </div> -->
      <div class="p-6">
        <div v-if="isCustom">
          <vs-textarea
          label="Add Custom HTML" v-model="rawHtml"
          v-validate="'required'"
         />
        <div class="flex p-3 pl-0">
          <vs-checkbox v-model="htmlDltable">Deletable HTML</vs-checkbox>
        </div>
         <div class="flex p-3 pl-0">
          <vs-checkbox v-model="htmlEditable">Editable HTML</vs-checkbox>
        </div>
         <div class="flex p-3 pl-0">
          <vs-checkbox v-model="htmlReuseable">Reusable Section</vs-checkbox>
        </div>
        <vs-row class="mb-base" v-if="htmlReuseable">
        <vs-input v-model="htmlTitle" label="Title" class="w-full mb-base"></vs-input>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" v-if="htmlImg">
          <img :src="htmlImg" alt="" width="300px" height="200px">
        </vs-col>
        <vs-col  vs-w="12">
            <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.htmlImg == null ? "Upload" : "Update" }} Thumbnail</vs-button>
            <vs-button v-if="htmlImg" type="flat" color="danger" @click.native="htmlImg = null">Remove</vs-button>
          </div>
        </vs-col>
      </vs-row>
        </div>
        <span v-else>
        <ul class="" >
          <li class="w-full p-2 font-semibold" v-for="(block,index) in Blocks" :key="index" @click="setBlock(block)">
            <span class="mt-5 cursor-pointer">
              <label for="" class="font-bold text-center w-full">{{block.title}}</label>
              <img :src="block.img" width="100%"/>
            </span>
          </li>
        </ul>
        <ul class="" >
          <li class="w-full p-2 font-semibold" v-for="(block,index) in staticBlocks" :key="index" @click="setBlock(block)">
            <span class="mt-5 cursor-pointer">
              <label for="" class="font-bold text-center w-full">{{block.title}}</label>
              <img :src="block.img" width="100%"/>
            </span>
          </li>
        </ul>
        <ul>
          <li lass="w-full p-2 font-semibold" @click="isCustom = true">
            <span class="mt-5 cursor-pointer">
              <label for="" class="font-bold text-center w-full">Add Custom HTML</label>
              <img src="https://dev3.barqsol.com/snipt/action.PNG" width="100%"/>
            </span>
          </li>

        </ul>
        </span>
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer" v-if="isCustom" >
        <vs-button type="filled" class="mr-6" color="primary" :disabled="!isPageValid" @click.native="SaveRaw()">Create</vs-button>
        <vs-button type="border" color="danger"  @click.native="isCustom = false">Back</vs-button>
    </div>
    <div class="flex flex-wrap items-center p-6" slot="footer" v-else>
        <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {GET_BLOCK_CONTENT,SAVE_BLOCKS_SECTION,GET_STATIC_BLOCKS } from "@/graphql";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: String,
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      isCustom:false,
      rawHtml:null,
      isValidHtml:false,
      htmlDltable:true,
      htmlEditable:true,
      htmlReuseable:false,
      htmlImg:null,
      htmlTitle:null,
      staticBlocks:[],
      Blocks:[
          {
             "img":"https://dev3.barqsol.com/snipt/food.PNG",
             "title":"Food Menu",
             "name":"sb-foodmenu",
             "html":``,
             "type":"static"
          },
                   {
            "img":"https://dev3.barqsol.com/snipt/slider.png",
            "title":"Slider",
            "name":"sb-slider",
            "html":``,
            "type":"global",
          },
          {
            "img":"https://dev3.barqsol.com/snipt/program.PNG",
            "title":"Programs",
            "name":"sb-program",
            "html":``,
            "type":"global",
          },
          {
            "img":"https://dev3.barqsol.com/snipt/center.PNG",
            "title":"About",
            "name":"sb-about",
            "html":``,
            "type":"static",
          },
          {
            "img":"https://dev3.barqsol.com/snipt/center2.PNG",
            "title":"Center",
            "name":"sb-center",
            "html":``,
            "type":"static",
          },
           {
            "img":"https://dev3.barqsol.com/snipt/action.PNG",
            "title":"Center",
            "name":"sb-action",
            "html":``,
            "type":"static",
          },
          {
            "img":"https://dev3.barqsol.com/snipt/test.PNG",
            "title":"Testimonial",
            "name":"sb-testimonial",
            "html":``,
            "type":"global",
          },
          {
            "img":"https://kvadmin01.s3.us-east-2.amazonaws.com/WebTemplates/Test2/sections/static/sb-programdetails/sb-programdetails.PNG",
            "title":"Program Details",
            "name":"sb-programdetails",
            "html":``,
            "type":"static",
          }
      ],
    }
  },
  watch: {
    isSidebarActive (val) {
      if(val){
        this.isCustom=false
        this.rawHtml=null
        this.htmlDltable=true
        this.htmlEditable=true
        this.htmlReuseable=false
        this.htmlImg=null
        this.htmlTitle=null
      }

    },
    

  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isPageValid () {
      if(this.htmlReuseable){
           return !this.errors.any() && this.htmlImg && this.rawHtml && this.htmlTitle
      }
      else{
          return !this.errors.any() && this.rawHtml
      }
      
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
  },
  methods: {
    changeClass(){
      let doc = new DOMParser().parseFromString(this.rawHtml, "text/html");
      var section = doc.body.firstChild
      if(this.htmlDltable){
      section.classList.add('section-dltable');
      section.setAttribute("data-gjs-type", "dltable")
      section.setAttribute("data-gjs-removable", "true")
      var firstchild= section.firstElementChild
      firstchild.setAttribute("data-gjs-removable", "false")
      firstchild.classList.add('nondltable');
      }
      if(this.htmlEditable){
      const ps = doc.querySelectorAll("p,li,h1,h2,h3,h4,h5,h6");
      ps.forEach(p => {
          p.setAttribute("data-gjs-editable", "true")
          p.classList.add('editabledata');
      });
      }
        // for (p of ps) {
        //   if(p){
        //       console.log(p)
        //   }
      

        // }
         console.log(section)
        //  let div = doc.body.firstChild;
        //   div = section.outerHTML;
 
        var block = {"html":section.outerHTML}
        this.$emit('setBlock',block)
        if(this.htmlReuseable){
         this.rawHtml=section.outerHTML
         this.staticBlockId=new Date().valueOf()
         var block_obj = {
            "img": this.htmlImg,
            "title": this.htmlTitle,
            "name": this.htmlTitle+"-"+this.staticBlockId,
            "html":``,
            "type":"static",
        }
         this.staticBlocks.push(block_obj)
         this.saveBlocks();
         this.$emit('closeSidebar')

        }

    },
    SaveRaw(){
       if(this.rawHtml){
         var _this = this
         var htmlTagValidator = require('html-tag-validator')
          htmlTagValidator(this.rawHtml, function (err, ast) {
          if (err) {
             _this.$vs.notify({
                title: "Blocks",
                text: err.message,
                color: "danger",
                position: "top-right",
              });
            throw err;
          } else {
                _this.changeClass()

          }
        });
        console.log(this.isValidHtml)
      

       }
    },
    newcheck(val){
      if(val){
         this.isCustom = false
      }
      if(val){
        this.isCustom = true
      }
    },
    setBlock(block){
        // if(block.type==='global'){
        this.$apollo
        .mutate({
          mutation: GET_BLOCK_CONTENT,
          variables: {
            name:block.name,
            site:this.$route.params.siteName,
            type:block.type
          },
        })
        .then((response) => {
          console.log(response)
          if(response.data.getBlockContent.status === 'Success'){
                 var block ={"html":response.data.getBlockContent.content}
                 this.$emit('setBlock',block)
                 this.$emit('closeSidebar')
          }


        })
        .catch((error) => {
          console.log(error);
        });
        // }
        // else{
        //     this.$emit('setBlock',block)
        //     this.$emit('closeSidebar')
        // }
    },
saveBlocks(){
      var data = {"staticBlocks":this.staticBlocks}  
       data = JSON.stringify(data)
       const site = this.$route.params.siteName;
       this.$apollo
          .mutate({
            mutation: SAVE_BLOCKS_SECTION,
            variables: {
               site:site,
               data:data,
               html:this.rawHtml,
               block:this.htmlTitle+"-"+this.staticBlockId,
            },
          })
          .then((response) => {
             console.log(response)
          })
          .catch((error) => {
            console.log(error);
          });
},   
updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
         const reader = new FileReader()
        reader.onload = e => {
          this.htmlImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    initValues () {
 
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
 
          



        }
      })
    },
  },
  created(){
        this.$apollo
        .mutate({
          mutation: GET_STATIC_BLOCKS,
           variables: {
            site: this.$route.params.siteName,
          },
        })
        .then((response) => {
          if(response.data.getStaticBlocks.data){
          var data = JSON.parse(response.data.getStaticBlocks.data)
          this.staticBlocks =  data.staticBlocks
        }
         
          //  this.menu_temp = response.data.getProgramTemp.data
          //  var menu=JSON.parse(response.data.getProgramTemp.pro_data)
          //  this.$store.dispatch('setBuilderMenu', menu)
          //  localStorage.setItem('web-data-url',response.data.getMenuTemp.url)

          //  var menu_data=this.$store.getters.getBuilderMenu
          //  this.menuData=JSON.parse(menu_data).menu
          //  localStorage.setItem('menu-data',response.data.getMenuTemp.menu_data)
          //  console.log(this.menuData)
        })
        .catch((error) => {
          console.log(error);
        });
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
